import React from 'react'

const Question = props => {
  return (
    <svg
      width={'54'}
      height={'45'}
      viewBox={'0 0 54 45'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
      className={props.classes}
    >
      <path
        d={
          'M25.2895 35V29.8366C39.0945 30.8694 44.1213 16.4119 39.0945 8.15077C34.0678 -0.110398 20.0226 -3.20838 13 9.87181L17 12.5M29 40.5C29 42.433 27.433 44 25.5 44C23.567 44 22 42.433 22 40.5C22 38.567 23.567 37 25.5 37C27.433 37 29 38.567 29 40.5Z'
        }
        stroke={'black'}
        strokeWidth={'0.6'}
      />
    </svg>
  )
}

export default Question
